//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  methods: {
    checkOrder() {
      this.$router.push({ path: "/szoperation/order/list" });
    },
    nextOrder() {
      this.$router.push({ path: "/szoperation/order/place" });
    },
  },
};
